import React, { useContext, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Image, Table } from 'antd';
import { SorterResult } from 'antd/lib/table/interface';
import { sortOrderType } from 'common/utils';
import { rootContext } from 'stores';
import { ITransactionInfo, IUser } from 'types';
import dayjs from 'dayjs';

export type CreateduserstableableProps = {
  id: string;
};

const Createduserstable: React.FC<CreateduserstableableProps> = observer(
  ({ id }) => {
    const {
      UsersStore: {
        getCreatedByUsers,
        setState,

        state: {
          data: { userDetail, userCreatedParams },
          data
        }
      }
    } = useContext(rootContext);
    const { limit, offset } = userCreatedParams;

    useEffect(() => {
      getCreatedByUsers({ userId: id, ...userCreatedParams });
    }, [getCreatedByUsers, id, setState, userCreatedParams]);

    const onChange = (pagination: any, _: any, sort: any) => {
      const sortInfo = sort as SorterResult<ITransactionInfo>;

      setState({
        data: {
          ...data,
          userCreatedParams: {
            ...userCreatedParams,
            limit: pagination.pageSize || userCreatedParams.limit,
            offset: ((pagination.current || 1) - 1) * pagination.pageSize,
            ...(sortInfo.columnKey && sortInfo.order
              ? {
                  sortField: sortInfo.columnKey,
                  sortBy: sortOrderType(sortInfo.order)
                }
              : {})
          }
        }
      });
    };

    return (
      <Table<IUser>
        rowKey="id"
        title={() => 'Created Users'}
        className="Table_block_main topSpace"
        dataSource={userDetail.user_created || []}
        pagination={{
          current: Number((offset / limit).toFixed(0)) + 1,
          pageSize: limit,
          total: userDetail.user_total_count,
          showSizeChanger: true,
          pageSizeOptions: ['10', '15', '20']
        }}
        onChange={onChange}
        columns={[
          {
            dataIndex: 'username',
            align: 'center',
            title: 'Username',
            key: 'username',
            sorter: true
          },
          {
            dataIndex: 'email',
            align: 'center',
            title: 'Email',
            key: 'email',
            sorter: true
          },
          {
            dataIndex: 'userType',
            align: 'center',
            title: 'Role',
            key: 'role',
            sorter: false
          },
          {
            dataIndex: 'userImage',
            align: 'center',
            title: 'User Image',
            key: 'userImage',
            render: value =>
              value ? (
                <div className="tableImage">
                  <Image className="tableImage" src={value} alt="" />
                </div>
              ) : (
                'No Image'
              )
          },
          {
            dataIndex: 'credit',
            align: 'center',
            title: 'Credit',
            key: 'credit',
            render: (value: number) => value?.toFixed(2) || 0
          },
          {
            dataIndex: 'createdAt',
            align: 'center',
            title: 'Created At',
            key: 'createdAt',
            sorter: true,
            render: value => dayjs(value).format('DD/MM/YYYY HH:mm')
          }
        ]}
      />
    );
  }
);

export default Createduserstable;
